import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { StoreModule } from "@ngrx/store";
import { SharedModule } from "../shared/shared.module";
import { ViewPageComponent } from './components/view-page/view-page.component';
import * as fromTransactionView from './reducers';
import { ViewDetailsComponent } from './components/view-details/view-details.component';

const COMPONENTS = [
    ViewPageComponent,
    ViewDetailsComponent
]

@NgModule({
    declarations: [COMPONENTS],
    imports: [
        CommonModule,
        SharedModule,
        RouterModule,
        StoreModule.forFeature(
            fromTransactionView.transactionViewFeatureKey,
            fromTransactionView.reducers
        )
    ],
    exports: [ViewPageComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TransactionViewModule { }
